import React from "react";
import { Link } from "gatsby";
import { Case_Arrow, Case_ArrowCustomusa } from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

const Caseusa = () => {
  return (
    <section className="case_flex">
      <div className="flex_item" style={{ backgroundColor: "#1A5DAD" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../images/services-usa/custom/case-logo-1.webp"
              alt="tekrevol_custom"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={380}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>Waste Connections RMO</h3>
            <Link
              to="/case-studies/waste-connections-rmo"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure">
          <StaticImage
            src="../../images/services-usa/custom/case-study-1.webp"
            alt="Tag: Software Development Project - S.E.L.F App By Project Impact"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={810}
            height={430}
          />
        </div>
      </div>
      <div className="flex_item web" style={{ backgroundColor: "#F3F3F3" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../images/services-usa/custom/case-logo-2.webp"
              alt="tekrevol_custom"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={175}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3 style={{ color: "#0047BA" }}>
              The S.E.L.F App by Project Impact MS
            </h3>
            <Link
              to="/case-studies/impact"
              className="case-usabtn"
              aria-label="TekRevol Contact"
              style={{ color: "#0047BA" }}
            >
              View Case Study {Case_ArrowCustomusa}
            </Link>
          </div>
        </div>
        <div className="case_figure website">
          <StaticImage
            src="../../images/services-usa/custom/case-study-2.webp"
            alt="Software Development Project - S.E.L.F App By Project Impact"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={405}
            height={365}
          />
        </div>
      </div>
      <div className="flex_item web" style={{ backgroundColor: "#01043F" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../images/services-usa/custom/case-logo-3.webp"
              alt="tekrevol_custom"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={185}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>A Inventory Management and Product Supplies Business Portal</h3>
            <Link
              to="/case-studies/stock-ship"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure website">
          <StaticImage
            src="../../images/services-usa/custom/case-study-3.webp"
            alt="Software Development Project - Stock Ship"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={405}
            height={365}
          />
        </div>
      </div>
    </section>
  );
};

export default Caseusa;
